import { render, staticRenderFns } from "./companyRealtime.vue?vue&type=template&id=1af8b852"
import script from "./companyRealtime.vue?vue&type=script&lang=js"
export * from "./companyRealtime.vue?vue&type=script&lang=js"
import style0 from "./companyRealtime.vue?vue&type=style&index=0&id=1af8b852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports